import { useState } from "react";
import { HashLoader } from "react-spinners";
import Failuremessage from "./failuremessage";
import axios from "axios";


export default function RegisterEmp(){
    const [loading,setLoading] = useState(false);
    const rootUrl = "http://localhost:3000";
  const localrootUrl = "https://ahkserver.onrender.com";
    const [resTwo, setResTwo] = useState();
    const [formData, setFormData] = useState({
        email: "",
        name: "",
        password:"",
        role:"employee"
    });
    const [confirmpass, setconfirmpass] = useState();


    function checkEmail(){
      if(formData.email.includes("@") && formData.email.includes(".com") && formData.email.length>5){
        return {"success":"Valid"};
      }else{
        return {"failure":"*Invalid Email"};
      }
    }
    function checkPass(){
      if(formData.password.length>7){
        return {"success":"Password is good"};
      }else{
        return {"failure":"*Password Must be at least 8 characters"};
      }
    }
    function confirmpassword(){
      if(formData.password==confirmpass){
        return {"success":"Password is good"};
      }else{
        return {"failure":"*Password Doesn't Match"};
      }
    }

    function formTwoSubmit(event){
      if(checkEmail().success && checkPass().success && confirmpassword().success && formData.name.length>=3){
        setLoading(true);
        event.preventDefault();
        const fetchData = async ()=>{
          try{
            const dataposter = await axios.post(`${localrootUrl}/register`,formData,{withCredentials:true});
            const response = dataposter.data;
            if(response.failure || response.success){
              setLoading(false);
            }
            setResTwo(response);
          }catch(error){
              console.log(error);
              setLoading(true);
          }
        }
        fetchData();
        setFormData({
          email:"",
          name:"",
          password:"",
          role:""
        });
      }
    }




    return <div className="register">
    <form onSubmit={formTwoSubmit} className="former" style={{padding:"0vw"}}>
      <h2 className="updates">
      {loading?<HashLoader size={50} className="newloader" loading={loading}/>:resTwo?resTwo.failure?<Failuremessage custommessage={resTwo.failure} isFail={true}/>:<Failuremessage successmessage={resTwo.success} isFail={false}/>:<p className="updates">Enter Employee Information</p>}
      </h2>
      <div className="subform">
      <div className="form-col">
        <input
          className="inputtext"
          type="email"
          name="email"
          required
          placeholder="Enter Email"
          value={formData.email}
          onChange={(event) => setFormData({ ...formData, email: event.target.value })}
        />
        <label className="label-contact" style={{color:"red"}}>{checkEmail().failure?checkEmail().failure:null}</label>
      </div>
      <div className="form-col">
        <input
          className="inputtext"
          type="text"
          required
          name="name"
          placeholder="Enter Name"
          value={formData.name}
          onChange={(event) => setFormData({ ...formData, name: event.target.value })}
        />
        <label className="label-contact" style={{color:"red"}}>{formData.name.length>=3?null:"*Name must be at least 3 characters"}</label>
      </div>
      <div className="form-col">
        <input
          className="inputtext"
          type="password"
          required
          name="password"
          placeholder="Enter Password"
          value={formData.password}
          onChange={(event) => setFormData({ ...formData, password: event.target.value })}
        />
        <label className="label-contact" style={{color:"red"}}>{checkPass().failure?checkPass().failure:null}</label>
      </div>
      <div className="form-col">
        <input
          className="inputtext"
          type="password"
          required
          name="confirm"
          placeholder="Confrim Password"
          value={confirmpass}
          onChange={(event) => setconfirmpass(event.target.value)}
          />
          <label className="label-contact" style={{color:"red"}}>{confirmpassword().failure?confirmpassword().failure:null}</label>
      </div>
        <select className="inputtext" id="cars" value={formData.role} name="gender" onChange={(event)=>{setFormData({...formData,role:event.target.value})}}>
              <option value="admin">Admin</option>
              <option value="employee">Employee</option>
        </select>
      </div>
        <button className="submit" disabled={checkEmail().success && checkPass().success && confirmpassword().success && formData.name.length>=3 ? false:true} style={checkEmail().success && checkPass().success && confirmpassword().success && formData.name.length>=3 ?null:{opacity:0.5,cursor:"not-allowed"}} type="submit">Submit</button>
    </form>
    </div>

}